export type ReplacementsType = {
  search: string;
  replace: string;
}[];

export const replacePlaceholders = (replacements: ReplacementsType, text: string): string => {
  let result = text;
  replacements.forEach((replacement) => {
    result = result.replace(new RegExp(replacement.search, 'g'), replacement.replace);
  });
  return result;
};

export type UserReplacement = {
  name?: {
    salutation?: string;
    firstname?: string;
    lastname?: string;
  };
  email?: string;
};

export function getUserReplacements(user: UserReplacement): ReplacementsType {
  const salutation = user.name?.salutation?.trim() ?? '';
  const firstname = user.name?.firstname?.trim() ?? '';
  const lastname = user.name?.lastname?.trim() ?? '';
  const fullName = [firstname, lastname].filter(Boolean).join(' ');
  const email = user.email?.trim() ?? '';

  return [
    { search: '%%salutation%%', replace: salutation },
    { search: '%%vorname%%', replace: firstname },
    { search: '%%firstname%%', replace: firstname },
    { search: '%%nachname%%', replace: lastname },
    { search: '%%lastname%%', replace: lastname },
    { search: '%%name%%', replace: fullName },
    { search: '%%mail%%', replace: email },
  ];
}
